import PropTypes from 'prop-types';
import {SelectEntity} from '@ozgene/gp5.components.select-entity';
import {findTeams} from 'Teams/service/TeamService';

export default function SelectTeam(props) {
  const {label, ...restProps} = props;

  return <SelectEntity getEntities={findTeams} label={label} {...restProps} />;
}

SelectTeam.propTypes = {
  label: PropTypes.string,
};

SelectTeam.defaultProps = {
  label: 'Team',
};
